import { Controller } from "@hotwired/stimulus"

const LV_BANKS = {
  HABA: { swift: "HABALV22", name: "Swedbank" },
  UNLA: { swift: "UNLALV2X", name: "SEB" },
  RIKO: { swift: "RIKOLV2X", name: "Luminor" },
  PARX: { swift: "PARXLV22", name: "Citadele" },
  LAPB: { swift: "LAPBLV2X", name: "LPB Bank" },
  SIGL: { swift: "SIGLLV2X", name: "Signet Bank" },
  CBBR: { swift: "CBBRLV22", name: "BluOr Bank" },
}

export default class extends Controller {
  static targets = ["iban", "swift", "bankName", "status"]
  static values  = { debounce: { type: Number, default: 600 } }

  connect() {
    this.timer = null
  }

  lookup() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.fetchBankDetails(), this.debounceValue)
  }

  async fetchBankDetails() {
    const iban = this.ibanTarget.value.replace(/\s/g, "").toUpperCase()
    if (iban.length < 15) return

    if (iban.startsWith("LV")) {
      this.resolveLvIban(iban)
      return
    }

    await this.resolveViaApi(iban)
  }

  resolveLvIban(iban) {
    const bankCode = iban.slice(4, 8)
    const bank     = LV_BANKS[bankCode]

    if (bank) {
      this.fill(bank.swift, bank.name)
      this.setStatus("✓", "success")
    } else {
      this.setStatus("Nekorekts konta numurs, aizpildiet manuāli", "warning")
    }
  }

  async resolveViaApi(iban) {
    this.setStatus("...", "muted")

    try {
      const res  = await fetch(`https://openiban.com/validate/${iban}?getBIC=true&validateBankCode=true`)
      const data = await res.json()

      if (data.valid && data.bankData?.bic) {
        this.fill(data.bankData.bic, data.bankData.name)
        this.setStatus("✓", "success")
      } else {
        this.fill("", "")
        this.setStatus("Nekorekts konta numurs, aizpildiet manuāli", "warning")
      }
    } catch {
      this.setStatus("Nekorekts konta numurs, aizpildiet manuāli", "warning")
    }
  }

  fill(swift, bankName) {
    this.swiftTarget.value    = swift
    this.bankNameTarget.value = bankName
  }

  setStatus(message, type) {
    this.statusTarget.textContent = message
    this.statusTarget.className   = `form-text text-${type}`
  }
}